import React from "react";

import AdminHome from "../Admin/Pages/AdminHome";

function HomePage() {
  return (
    <div className="flex flex-col h-full py-5 overflow-y-auto">
      {/* Admin and supervisors HomePAge  */}
      <AdminHome />
    </div>
  );
}

export default HomePage;
